import { URLS } from '../../../constants';
import apiClient from '../../client';

const MedicalRecordApi = {
  MedicalRecordGrid: ({
    heading,
    roleId,
    type,
    assignedTo,
    pagination,
    order,
    name,
    serachValue,
    searchKey,
    filterValue,
  }: {
    heading: string;
    roleId: string;
    type: string;
    assignedTo: string;
    pagination: {
      startIndex: number;
      noOfRecords: number;
    };
    name: string;
    order: string;
    filterValue: any;
    serachValue?: any;
    searchKey?: any;
    filterType?: any;
    subType?: any;
  }) => {
    let otherFilterData = [];
    if (serachValue) {
      otherFilterData.push({
        filterKey: searchKey || '',
        filterValue: serachValue ? serachValue : '',
      });
    }
    if (typeof filterValue !== 'string') {
      otherFilterData = [...otherFilterData];
    } else if (typeof filterValue === 'string' && filterValue.length > 0) {
      otherFilterData.push({
        filterKey: '',
        filterValue: serachValue ? serachValue : '',
      });
    }
    return apiClient.post(URLS.medicalRecordGrid, {
      data: {
        heading,
        roleId,
        type,
        pagination,
        assignedTo,
        filter: typeof filterValue !== 'string' ? filterValue : [],
        otherFilterData,
        sorting: {
          order: order || 'DESC',
          fieldName: name || 'createdDate',
        },
      },
    });
  },
};

export default MedicalRecordApi;
